import React from 'react';
import moment from "moment";
import CountryFlag from '../../countryflag/countryFlag';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import { useForm } from 'react-hook-form';

const CorrectivesPanel = (props) => {
    const { register, handleSubmit } = useForm();

    const filterReturnsToOpen = (data) => {
        if (props.reopenableClosedReturns && props.reopenableClosedReturns.length > 0) {
            const formReturns = Object.keys(data).map(key => data[key]).filter(r => r.reOpen);
            const returnsToOpen = props.reopenableClosedReturns.filter(r => formReturns.find(x => x.id === r.id));
            props.onSubmit(returnsToOpen);
        } else {
            props.onSubmit([]);
        }
    };

    const reopenableReturnsRows = (props.reopenableClosedReturns !== null && props.reopenableClosedReturns !== undefined) ? props.reopenableClosedReturns.map(c => {
        const rowId = `corrective-${c.id}`;
        const checkboxName = `${rowId}.reOpen`;
        const idName = `${rowId}.id`;
        return <tr key={c.id}>
            <td>
                <input data-testid={`${checkboxName}.input`} type="checkbox" {...register(checkboxName)} id={checkboxName} />
                <label data-testid={`${checkboxName}.label`} htmlFor={checkboxName}></label>
                <input type="hidden" {...register(idName, { value: c.id })} />
            </td>
            <td><CountryFlag countryCode={c.country} showCode={true} /></td>
            <td>{c.name}</td>
            <td>{c.returnType}</td>
            <td>{c.status}</td>
            <td>{moment.utc(c.vatReturnStartDate).format('YYYY-MM-DD')}</td>
            <td>{moment.utc(c.vatReturnEndDate).format('YYYY-MM-DD')}</td>
            <td>{moment.utc(c.dueDate).format('YYYY-MM-DD')}</td>
            <td className='align-right'>{c.daysUntilDue}</td>
        </tr>
    }) : null;

    return (<div>
        <h2 className="header-spacing">{LANGUAGES_CONTROLLER.format(props.languages, 'correctivesPanel_header')}</h2>
        <p className="font-bold">{LANGUAGES_CONTROLLER.format(props.languages, 'correctivesPanel_description')}
        </p>
        <s-table-container data-testid="correctives-table" tabindex="0">
            <table>
                <thead className="text-uppercase">
                    <tr>
                        <th></th>
                        <th>{LANGUAGES_CONTROLLER.format(props.languages, 'country')}</th>
                        <th>{LANGUAGES_CONTROLLER.format(props.languages, 'company')}</th>
                        <th>{LANGUAGES_CONTROLLER.format(props.languages, 'reportType')}</th>
                        <th>{LANGUAGES_CONTROLLER.format(props.languages, 'status')}</th>
                        <th>{LANGUAGES_CONTROLLER.format(props.languages, 'correctivesPanel_fromDate')}</th>
                        <th>{LANGUAGES_CONTROLLER.format(props.languages, 'correctivesPanel_toDate')}</th>
                        <th>{LANGUAGES_CONTROLLER.format(props.languages, 'correctivesPanel_dueDate')}</th>
                        <th>{LANGUAGES_CONTROLLER.format(props.languages, 'correctivesPanel_daysToDueDate')}</th>
                    </tr>
                </thead>
                <tbody>
                    {reopenableReturnsRows}
                </tbody>
            </table>
        </s-table-container>
        <p>{LANGUAGES_CONTROLLER.format(props.languages, 'correctivesPanel_confirmationText')}</p>
        <button name='Yes' onClick={handleSubmit(filterReturnsToOpen)}>{LANGUAGES_CONTROLLER.format(props.languages, 'correctivesPanel_submitButtonYes')}</button>
        <button name='No' onClick={props.onClose}>{LANGUAGES_CONTROLLER.format(props.languages, 'correctivesPanel_closeButtonNo')}</button>
    </div>);
};

export default CorrectivesPanel;